import { SxProps } from '@mui/joy/styles/types';
import { ChangeEvent, CSSProperties, KeyboardEvent } from 'react';
import {
  Control,
  FieldError,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';

import { IRadioChoice } from 'core/types';
import { Orientation, Size } from 'theme/enums';

import RadioGroupInputView from './RadioGroupInputView';
import RadioGroupInputWithControllerView from './RadioGroupInputWithControllerView';

interface IExtraFormFieldProps {
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
}

export interface IProps extends IExtraFormFieldProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  name?: string;
  label?: string | string[];
  tooltip?: string;
  defaultValue?: string;
  value?: string;
  choices?: IRadioChoice[];
  required?: boolean;
  disabled?: boolean;
  onKeyDown?: (event: KeyboardEvent<HTMLSpanElement>) => void;
  onChange?: (event: ChangeEvent<HTMLSpanElement> | KeyboardEvent<HTMLSpanElement>) => void;
  changeOnKeyDown?: boolean;
  size?: Size;
  labelSize?: Size;
  // Radios side by side instead of one per line.
  orientation?: Orientation;
  renderRadio?: (
    choice: IRadioChoice,
    onChange?: (event: ChangeEvent<HTMLSpanElement> | KeyboardEvent<HTMLSpanElement>) => void,
    changeOnKeyDown?: boolean,
    disabled?: boolean
  ) => JSX.Element;
  wrapperStyle?: CSSProperties;
  labelSxProps?: SxProps;
}

const RadioGroupInput = (props: IProps) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { setValue, getValues, ...other } = props;

  if (props?.control) {
    return <RadioGroupInputWithControllerView {...other} />;
  }

  return <RadioGroupInputView {...other} />;
};

export default RadioGroupInput;
